export const CONTACT_US_LINK = `https://${window.location.hostname}/contact-us`;
